// Ids match the reseeds in 20260729190000_firestore_migration_seeds (order, work order) and
// 20260903160000_reseed_manufacturing_order_item_status (order item) — all three tables share them.
export var ManufacturingLifecycleStatus;
(function (ManufacturingLifecycleStatus) {
    ManufacturingLifecycleStatus[ManufacturingLifecycleStatus["DRAFT"] = 7] = "DRAFT";
    ManufacturingLifecycleStatus[ManufacturingLifecycleStatus["ISSUED"] = 8] = "ISSUED";
    ManufacturingLifecycleStatus[ManufacturingLifecycleStatus["PICK"] = 9] = "PICK";
    ManufacturingLifecycleStatus[ManufacturingLifecycleStatus["IN_PROGRESS"] = 10] = "IN_PROGRESS";
    ManufacturingLifecycleStatus[ManufacturingLifecycleStatus["IN_TESTING"] = 11] = "IN_TESTING";
    ManufacturingLifecycleStatus[ManufacturingLifecycleStatus["COMPLETED"] = 12] = "COMPLETED";
    ManufacturingLifecycleStatus[ManufacturingLifecycleStatus["CANCELLED"] = 13] = "CANCELLED";
})(ManufacturingLifecycleStatus || (ManufacturingLifecycleStatus = {}));
/** Seeded display names of the ids above — the only operator-facing spelling of a status. */
export const manufacturingLifecycleStatusName = {
    [ManufacturingLifecycleStatus.DRAFT]: 'Draft',
    [ManufacturingLifecycleStatus.ISSUED]: 'Issued',
    [ManufacturingLifecycleStatus.PICK]: 'Pick',
    [ManufacturingLifecycleStatus.IN_PROGRESS]: 'In Progress',
    [ManufacturingLifecycleStatus.IN_TESTING]: 'In Testing',
    [ManufacturingLifecycleStatus.COMPLETED]: 'Completed',
    [ManufacturingLifecycleStatus.CANCELLED]: 'Cancelled',
};
//# sourceMappingURL=manufacturing-lifecycle-status.js.map